<template>
  <button
    class="text-c-3 hover:text-c-1 underline"
    type="button">
    <slot />
  </button>
</template>
